// Haengt beim Absenden einer Suche den Ausschluss an: aus "protein" wird serverseitig
// "protein -tag:probe". Shopify filtert dann schon beim Suchen, damit stimmen Trefferzahl
// und Blaetterung — im Theme liesse sich nur die geladene Seite saeubern.
//
// Der Zusatz geht ueber ein verstecktes Feld, das sichtbare bleibt unberuehrt: Schriebe man
// ihn dort hinein, saehe man ihn im Moment des Absendens noch kurz aufblitzen.
//
// Ohne dieses Modul geht die Suche unveraendert raus; die Seite ueberspringt die Treffer
// dann selbst, nur die Trefferzahl faellt etwas zu hoch aus.

const MARKE = '-tag:';

function vorbereiten(form) {
  const feld = form.querySelector('input[name="q"]');
  const tags = form.dataset.searchExclude;
  if (!feld || !tags) return;

  const begriff = feld.value.trim();
  if (!begriff || begriff.includes(MARKE)) return;

  const teile = tags
    .split(',')
    .map((t) => t.trim())
    .filter(Boolean)
    // Ein Tag mit Leerzeichen braucht Anfuehrungszeichen, sonst liest Shopify nur das erste Wort.
    .map((t) => (t.includes(' ') ? `${MARKE}"${t}"` : MARKE + t));
  if (!teile.length) return;

  const versteckt = document.createElement('input');
  versteckt.type = 'hidden';
  versteckt.name = 'q';
  versteckt.value = `${begriff} ${teile.join(' ')}`;
  form.append(versteckt);

  // Nur eines der beiden darf „q“ heissen, sonst kaeme der Begriff doppelt an.
  feld.removeAttribute('name');

  /*
    Zuruecksetzen, sobald der Browser mit dem Absenden durch ist. Bei einem echten
    Seitenwechsel spielt das keine Rolle mehr — bricht die Navigation aber ab, etwa weil
    der Nutzer zurueckgeht, funktioniert das Formular sonst nicht mehr.
  */
  setTimeout(() => {
    feld.name = 'q';
    versteckt.remove();
  });
}

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (form instanceof HTMLFormElement && form.dataset.searchExclude) vorbereiten(form);
  },
  true
);
